<template>
  <v-toolbar
    id="core-toolbar"

    flat
    prominent
    style="background: #eee;"
  >
    <div class="v-toolbar-title">
      <v-toolbar-title
        class="tertiary--text font-weight-light"
      >
        <v-toolbar-side-icon @click.stop="toggleSidebar" v-if="responsive" color="tertiary"></v-toolbar-side-icon>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items>
      <v-spacer></v-spacer>
      <v-btn icon @click.stop="logout">
        <v-icon color="tertiary">exit_to_app</v-icon>
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Toolbar',
  data: () => ({
    dialog: false,
    drawer: null,
    notifications: [
      'Mike, John responded to your email',
      'You have 5 new tasks',
      'You\'re now a friend with Andrew',
      'Another Notification',
      'Another One',
    ],
    title: null,
    responsive: false,
    responsiveInput: false,
  }),

  watch: {
    $route(val) {
      this.title = val.meta.title;
    },
  },

  mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
    this.title = this.$router.currentRoute.meta.title;
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted);
  },

  computed: {
    ...mapGetters({
      username: 'auth/username',
    }),
  },
  methods: {
    ...mapActions({
      signOut: 'auth/signOut',
      toggleSidebar: 'ui/toggleSidebar',
    }),
    onClickBtn() {
      // this.setDrawer(!this.$store.state.app.drawer);
    },
    onClick() {
      //
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
    logout() {
      this.signOut().then((success) => {
        if (success) {
          this.$router.push({ name: 'SignIn' });
        }
      });
    },
  },
};
</script>

<style scoped>
  #core-toolbar a {
    text-decoration: none;
  }
</style>
